// extracted by mini-css-extract-plugin
module.exports = {"primaryLight":"#fff","primaryDark":"#000","primaryColor":"#639","primaryDarkLighter":"#999"};